import { Segmented } from './ui/Segmented.js';

export type DateRange = '7d' | '30d' | '90d';

interface DateRangeSelectorProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

const OPTIONS = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
] as const;

/**
 * The time range — Kridt's Segmented control (spec 246, review P0-4 / P1-11).
 *
 * A time range is a PARAMETER: it changes how the same content is shown, so it
 * is segmented rather than tabbed. Spec 247 moved the radiogroup pattern into
 * the shared `Segmented`, which the theme choice uses too, so the keyboard
 * behaviour lives in one place. Gate 246.A.5 still proves this instance.
 */
export function DateRangeSelector({ value, onChange }: DateRangeSelectorProps) {
  return <Segmented options={OPTIONS} value={value} onChange={onChange} label="Date range" />;
}
